import React from 'react';
import { MicrophoneIcon } from '@heroicons/react/24/outline';

interface VoicemailTranscriptionProps {
  transcription?: string | null;
}

export const VoicemailTranscription: React.FC<VoicemailTranscriptionProps> = ({ transcription }) => {
  if (!transcription) return null;

  return (
    <div className="voicemail-transcription" onClick={(e) => e.stopPropagation()}>
      <MicrophoneIcon className="voicemail-transcription__icon" />
      <span className="voicemail-transcription__text">{transcription}</span>
    </div>
  );
};
